import { lazy } from 'react'

export const IdealWeightTime = lazy(() => import('./v1/IdealWeightTime'))
export const IdealWeightTimeV2 = lazy(() => import('./v2/IdealWeightTimeV2'))
export const IdealWeightTimeV3 = lazy(() => import('./v3/IdealWeightTimeV3'))
